


























import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
    name: 'WokDataGridHeader',

    props: {
        showAddAction: {
            type: [Boolean, String],
            default: false
        },
        showExportAction: {
            type: [Boolean, String],
            default: false
        },
        addActionLabel: {
            type: String,
            default: 'Add new'
        },
        exportActionLabel: {
            type: String,
            default: 'Export Excel'
        }
    },

    setup(props, context) {
        const addActionVisible = computed(() => {
            return props.showAddAction.toString() == 'true';
        });

        const exportActionVisible = computed(() => {
            return props.showExportAction.toString() == 'true';
        });

        const hasActions = computed(() => {
            return addActionVisible.value
                || exportActionVisible.value
                || context.slots.actions != null;
        })

        const onAddClick = () => {
            context.emit('click:add');
        }

        const onExportClick = () => {
            context.emit('click:export');
        }

        return {
            hasActions,
            addActionVisible,
            exportActionVisible,
            onAddClick,
            onExportClick
        }
    }
})
